import Papa from 'papaparse';

import {
  alertStatusMap,
  UNCLAIMED,
  CLAIMED,
  SCHEDULED,
  CLOSED_OUT,
} from './components/dashboard';
import { isAlertOnAnyDashboard } from '../../api-server/alertFilter';

export const getRandomElement = (array) => {
  return array[Math.floor(Math.random() * array.length)];
};

const getFormattedDateForDownloads = () => {
  const now = new Date();
  const month = String(now.getMonth() + 1).padStart(2, '0');
  const day = String(now.getDate()).padStart(2, '0');
  const year = now.getFullYear();
  const hours = String(now.getHours()).padStart(2, '0');
  const minutes = String(now.getMinutes()).padStart(2, '0');
  return `${month}/${day}/${year}-${hours}:${minutes}`;
};

const dateChanged = ({ fromStatus, toStatus }, actions) => {
  for (const action of actions) {
    const {
      altered: { from, to, reason = null },
    } = action;
    if (from === fromStatus && to === toStatus) {
      return {
        occurredOn: action.timestamp,
        reason,
        org: action.user.organization,
      };
    }
  }
  return {
    occurredOn: null,
    reason: null,
    org: null,
  };
};

const generateCSVRows = (data) => {
  const csvRows = data.map((alert) => ({
    AlertID: `="${alert.alertID}"`,
    Clinic: alert.existingClinic,
    ExistingClinic: alert.isTreeOnDashboard,
    Unrouteable: !isAlertOnAnyDashboard(alert),
    AlertDate: alert.alertDate,
    AppointmentDate: alert.appointmentDate,
    AlertStatus: alertStatusMap[alert.alertStatus],
    AlertType: alert.alertType,
    AlertZIP: alert.alertZIP,
    Insurance: alert.insuranceProvider,
    DischargeDate: alert.dischargeDate,
    ContactName: alert.facilityContact.facilityContactFullName,
    ContactPhone: alert.facilityContact.facilityContactPhoneNumber,
    ContactEmail: alert.facilityContact.facilityContactEmail,
    ContactOrganization: alert.facilityContact.facilityContactOrganization,
    PreferredLanguage: alert.preferredLanguage,
    PeerRequested: alert.indicators.isPeerRequested,
    Telehealth: alert.indicators.isTelehealth,
    Injectable: alert.indicators.isInjectable,
    Minor: alert.indicators.isMinor,
    CTI: alert.indicators.isCTI,
    IOP: alert.indicators.isIOP,
    PROS: alert.indicators.isPROS,
    PartialHospital: alert.indicators.isPartialHospital,
    OnTrack: alert.indicators.isOnTrack,
    MAT: alert.indicators.isMAT,
    OTP: alert.indicators.isOTP,
    DaysLapsed: alert.daysLapsed > 0 ? alert.daysLapsed : 0,
    DiagnosisCodes: alert.diagnosisCodes
      .map((diagnosisCode) => diagnosisCode.code)
      .join(', '),
    UnclaimedReason: dateChanged(
      { fromStatus: CLAIMED, toStatus: UNCLAIMED },
      alert.actionHistory.actions,
    ).reason,
    UnclaimedClinic: dateChanged(
      { fromStatus: CLAIMED, toStatus: UNCLAIMED },
      alert.actionHistory.actions,
    ).org,
    CloseOutReason: dateChanged(
      { fromStatus: SCHEDULED, toStatus: CLOSED_OUT },
      alert.actionHistory.actions,
    ).reason,
    ClaimedOn: dateChanged(
      { fromStatus: UNCLAIMED, toStatus: CLAIMED },
      alert.actionHistory.actions,
    ).occurredOn,
    ScheduledOn: dateChanged(
      { fromStatus: CLAIMED, toStatus: SCHEDULED },
      alert.actionHistory.actions,
    ).occurredOn,
    ClosedOutOn: dateChanged(
      { fromStatus: SCHEDULED, toStatus: CLOSED_OUT },
      alert.actionHistory.actions,
    ).occurredOn,
  }));
  return Papa.unparse(csvRows);
};

export const downloadData = (data, contentType) => {
  const blob = new Blob([generateCSVRows(data)], { type: 'text/csv' });
  const downloadURL = URL.createObjectURL(blob);
  const anchorLink = document.createElement('a');
  anchorLink.href = downloadURL;
  anchorLink.download = `ClinicRx_Download_${getFormattedDateForDownloads()}`;
  anchorLink.click();
  URL.revokeObjectURL(downloadURL);
};

export const getServerURL = () => {
  switch (process.env.NODE_ENV) {
    case 'local':
    case 'development':
    case 'staging': {
      return 'https://api-staging.clinicrx.io';
    }
    default: {
      return 'https://api.clinicrx.io';
    }
  }
};

export const getSocketURL = () => {
  switch (process.env.NODE_ENV) {
    case 'local': {
      return 'http://localhost:3000';
    }
    case 'development':
    case 'staging': {
      return 'https://socket-staging.clinicrx.io';
    }
    default: {
      return 'https://socket.clinicrx.io';
    }
  }
};
